<template>
    <v-container grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <icon-world class="animation-world" :progressValue="100"></icon-world>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12>
                <p>Vielen Dank &ndash; Dein individuelles Ergebnis
                    ist per Email auf dem Weg zu Dir.<br>
                    Schau gleich mal nach!</p>
                <!--
                Super!<br>
                Dein persönlicher Berater bekommt eine Kopie der Empfehlungen.
                Auch seine Daten übermitteln wir Dir per Mail!<br>
                Wir freuen uns auf Dich!
                -->
            </v-flex>
            <v-bottom-nav fixed :value="true" color="transparent" style="height:100%">
                <v-flex xs2 sm1>
                    <div class="display-flex">
                        <div class="center-by-margin">
                            <img @click="$router.push('willkommen')"  class="ui-btn" src="icons/qa/ui/btnBackward.svg" />
                        </div>
                    </div>
                </v-flex>
                <v-flex xs8 sm10>
                </v-flex>
                <v-flex xs1>
                    <div class="display-flex">
                        <div class="center-by-margin">

                        </div>
                    </div>
                </v-flex>
            </v-bottom-nav>
        </v-layout>
    </v-container>
</template>

<script>

    import { mapGetters } from "vuex";
    import IconWorld from "./IconWorld";

    export default {
        name: "MailRequest",
        data(){
            return {
                allActive: true
            }
        },
        components: {IconWorld},
        computed: {
        },
        methods:{
            backToRecommendation(){
                this.$router.push('recommendation');
            }
        }
    }
</script>

<style scoped>

</style>
